import React from "react";

const labels = ["Thắng", "Hòa", "Bại"];

const HandicapOddRate = ({ homeArray, awayArray }) => {
  const totalHome = homeArray[0] || 1;
  const totalAway = awayArray[0] || 1;

  const homeHadicapWinRate = (
    ((Number(homeArray[1]) || 0) / totalHome) *
    100
  ).toFixed(0);
  const homeHadicapVoidRate = (
    ((Number(homeArray[2]) || 0) / totalHome) *
    100
  ).toFixed(0);
  const homeHadicapLoseRate = (
    ((Number(homeArray[3]) || 0) / totalHome) *
    100
  ).toFixed(0);

  const awayHadicapWinRate = (
    ((Number(awayArray[1]) || 0) / totalAway) *
    100
  ).toFixed(0);
  const awayHadicapVoidRate = (
    ((Number(awayArray[2]) || 0) / totalAway) *
    100
  ).toFixed(0);
  const awayHadicapLoseRate = (
    ((Number(awayArray[3]) || 0) / totalAway) *
    100
  ).toFixed(0);

  const homeHadicapData = [
    homeHadicapWinRate,
    homeHadicapVoidRate,
    homeHadicapLoseRate,
  ];
  const awayHadicapData = [
    awayHadicapWinRate,
    awayHadicapVoidRate,
    awayHadicapLoseRate,
  ];

  return (
    <div className="px-[20px] w-full flex flex-col gap-2 items-center justify-center">
      <div
        className={
          "w-full  font-bold text-xs  flex flex-row gap-8 [&>*]:flex-1 [&>*]:text-center [&>*:first-child]:pl-[0] [&>*:last-child]:pr-[0] divide-league-dark-detail text-blur-gray"
        }
      >
        {labels.map((label, index) => (
          <div key={index} className={"flex flex-col gap-2 "}>
            <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
              <div
                className={
                  "w-[30px] h-[88px] flex flex-col justify-end bg-[#ebeff5] dark:bg-dark-slate rounded-tl rounded-tr text-button-blue-bet"
                }
              >
                <div>{homeHadicapData[index] || ""}%</div>
                <div
                  className={"bg-button-blue-bet"}
                  style={{ height: `${homeHadicapData[index]}%` }}
                ></div>
              </div>
              <div
                className={
                  "w-[30px]  h-[88px] flex flex-col justify-end bg-[#f6f5ef] dark:bg-dark-slate rounded-tl rounded-tr text-golden-yellow"
                }
              >
                <div>{awayHadicapData[index] || ""}%</div>
                <div
                  className={"bg-golden-yellow"}
                  style={{ height: `${awayHadicapData[index]}%` }}
                ></div>
              </div>
            </div>
            <div className={"w-full rounded font-semi-bold text-center"}>
              {label}
            </div>
          </div>
        ))}
      </div>

      <div className="text-blur-gray rounded-[10px] bg-white dark:bg-dark-slate dark:text-white p-2 px-5">
        Tỷ lệ châu Á ({homeArray[0] || 0} Trận - {awayArray[0] || 0} Trận)
      </div>
    </div>
  );
};

export default HandicapOddRate;
